import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=046de154"
import script from "./AppSwitcher.vue?vue&type=script&lang=js"
export * from "./AppSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=046de154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports